import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    gridNotas: {
        margin: 0,
        width: '100%',
        flexGrow: 0,
        display: 'flex',
        justifyContent: 'space-between',
       // height: '20mm',
        paddingLeft: '10mm',
        paddingRight: '10mm',
        flexDirection: 'row',
        // backgroundColor: '#fecc00',
        flexWrap: 'wrap',
        msFlexDirection: "column",
        borderTop: 1,
        borderTopStyle: 'solid',
        borderTopColor: 'beige'

    },


    gridEsq: {
        padding: '5mm',
        width: '50mm'
    },
    gridMeio: {
        display: 'flex',
        width: '60%',

        flexGrow: 1,
        alignItems: 'center'

    },
    gridDir: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center'

    },


}));

const NotasPag1 = (props) => {
   const {pagina, meio1 } = props;
   const classes = useStyles();

    return (
        <Grid container className={classes.gridNotas}>
           <Typography gutterBottom variant={"caption"}>* São considerados os registros com raspagem igual ou superior a 0.5mm</Typography>
            <Typography gutterBottom variant={"caption"}>* Número de Ordens de serviço distintas, desconsidera-se em branco, zero etc</Typography>
           <Typography gutterBottom variant={"caption"}>* Percentual de utilização considera número de dias trabalhados X 8h/dia.</Typography>
            <Typography gutterBottom variant={"caption"}>* Tempo médio da maquina em uso por ciclo de raspagem.</Typography>
        </Grid>
    );

}

export default (NotasPag1)